/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_TextInputs */

const zh_landing_cta_text = /** @type {(inputs: Landing_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教学工具应该为你服务，而不是反过来。立即加入 StudyOS！`)
};

const en_landing_cta_text = /** @type {(inputs: Landing_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teaching tools should work for you — not the other way around. Join StudyOS now!`)
};

const es_landing_cta_text = /** @type {(inputs: Landing_Cta_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las herramientas de enseñanza deberían trabajar para ti, no al revés. ¡Únete a StudyOS ahora!`)
};

/**
* | output |
* | --- |
* | "Teaching tools should work for you — not the other way around. Join StudyOS now!" |
*
* @param {Landing_Cta_TextInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_cta_text = /** @type {((inputs?: Landing_Cta_TextInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_TextInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_cta_text(inputs)
	if (locale === "en") return en_landing_cta_text(inputs)
	return es_landing_cta_text(inputs)
});